import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ChangeDatesModalState } from '../../../../../interfaces/src/lib/types/index';

const initialState: ChangeDatesModalState = {
  isChangeDatesModalOpen: false,
};

const changeDatesModalSlice = createSlice({
  name: 'changeDatesModal',
  initialState,
  reducers: {
    setIsChangeDatesModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isChangeDatesModalOpen = action.payload;
    },
  },
});

export const { setIsChangeDatesModalOpen } = changeDatesModalSlice.actions;
export default changeDatesModalSlice.reducer;
